import { useTranslate } from "@tolgee/react";

export function translateComponent(prefix: string) {
    const { t } = useTranslate();

    return (key: string, options?: any) => {
        return t(`${prefix}.${key}`, options);
    };
}
